import React from 'react';
import './invoice-screen.scss';
import { useInvoiceScreen } from './hooks/use-invoice-screen';
import { LoadingSpinner, SVGS } from '@zonofi/zono-money-design-system';
import {
  CategoryButton,
  FallBackScreen,
  InvoiceHeader,
  InvoiceList,
} from '@zonofi/zono-money-whatsapp-stack';
import { InvoiceStatusChips } from '../invoice-status-chips/invoice-status-chips';
import { isEmpty } from 'lodash';
import { FilterModal } from '@zonofi/seller-hub/components/filter/filter-modal';
import { FilterRoute } from '@zonofi/zono-money-store';

export const InvoiceScreen: React.FC = () => {
  const {
    showSearch,
    setShowSearch,
    searchKey,
    setSearchKey,
    error,
    isLoading,
    lastItemRef,
    onScroll,
    statusChips,
    appliedStatusFilter,
    filterPage,
    setFilterPage,
    openFiltersDrawer,
    appliedDateRange,
    applyNewDateRange,
    appliedFilters,
    invoicesData,
    isEndOfList,
    pageNo,
    getInvoiceListAPIResponse,
  } = useInvoiceScreen();

  return (
    <div className="invoice-screen">
      <div className="invoice-screen-header-category-container">
        <InvoiceHeader
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          showCategory={true}
          appliedDateRange={appliedDateRange}
          applyNewDateRange={applyNewDateRange}
          openFiltersDrawer={openFiltersDrawer}
        />
      </div>
      {error?.show && (
        <div className="invoice-screen-error-section font-primary">
          <h2 className=" font-primary">{error?.code}</h2>
          <span className="font-primary-semibold">{error?.message}</span>
        </div>
      )}
      <InvoiceStatusChips
        selectedStatus={appliedStatusFilter}
        statusChips={statusChips}
        appliedFilters={appliedFilters}
      />
      {isLoading ? (
        <div className="invoice-screen-loading">
          <LoadingSpinner />
        </div>
      ) : isEmpty(invoicesData) ? (
        <FallBackScreen
          image={SVGS.InvoiceEmptyState}
          message="No Invoices Found"
          description=""
          contentStyle={{
            justifyContent: 'center',
          }}
        />
      ) : invoicesData?.length > 0 ? (
        <>
          <div className="invoice-list" onTouchMove={onScroll}>
            <InvoiceList invoiceList={invoicesData} />
            <div
              ref={lastItemRef}
              className="lastItemRef"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
          {!isEndOfList &&
            pageNo !== 1 &&
            getInvoiceListAPIResponse.isFetching && (
              <div className="invoice-screen-list-loading font-primary">
                <LoadingSpinner size={'small'} />
              </div>
            )}
        </>
      ) : (
        !error?.show && (
          <div className="invoice-screen-loading">
            <LoadingSpinner />
          </div>
        )
      )}
      {/* main section end  */}
      <FilterModal
        open={!!filterPage}
        onClose={() => {
          setFilterPage('');
        }}
        route={FilterRoute.Invoice}
        filterPage={filterPage}
        dateSelectionMode="dateRange"
      />
    </div>
  );
};
